/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBraille = createReactComponent("braille", "IconBraille", [
  ["path", { d: "M15 5a1 1 0 1 0 2 0a1 1 0 0 0 -2 0z", key: "svg-0" }],
  ["path", { d: "M7 5a1 1 0 1 0 2 0a1 1 0 0 0 -2 0z", key: "svg-1" }],
  ["path", { d: "M7 19a1 1 0 1 0 2 0a1 1 0 0 0 -2 0z", key: "svg-2" }],
  ["path", { d: "M16 12h.01", key: "svg-3" }],
  ["path", { d: "M8 12h.01", key: "svg-4" }],
  ["path", { d: "M16 19h.01", key: "svg-5" }]
]);

export { IconBraille as default };
//# sourceMappingURL=IconBraille.js.map
